import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=3e89d9ea&scoped=true"
import script from "./Svg.vue?vue&type=script&lang=js"
export * from "./Svg.vue?vue&type=script&lang=js"
import style0 from "./Svg.vue?vue&type=style&index=0&id=3e89d9ea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89d9ea",
  null
  
)

export default component.exports